var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-item__content--recording"},[_c('div',{staticClass:"recording"},_vm._l((6),function(index){return _c('span',{key:index,staticClass:"recording__item"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }